import {Component} from 'panel';

import template from './index.jade';
import css from './index.styl?inline';

export class SlidingPaneDropdown extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'user-id': {type: `number`, description: `ID of user viewing the builder`},
    };
  }
  get config() {
    return {
      useShadowDom: true,
      css,
      template,
      helpers: {
        dropMenuChanged: (ev) => ev.detail && ev.detail.state === `closed` && this.closeBuilder(),
        getPanes: () => this.builderState.panes || [],
      },
    };
  }

  closeBuilder() {
    throw new Error(`closeBuilder method not implemented`);
  }

  updateBuilderState(attrs) {
    this.app.update({[this.builderStateReference]: {...this.builderState, ...attrs}});
  }

  get builderState() {
    return this.app.state[this.builderStateReference];
  }

  get builderStateReference() {
    const builderStateReference = this.app.builderStateReference;
    if (!builderStateReference) {
      throw new Error(`builderStateReference must be declared`);
    }
    return builderStateReference;
  }
}
